<template>
	<div class="item-content" style="align-items: baseline;">
		<div class="item-media">
			<button class="button button-fill color-deeppurple">{{(pageNo > 0)?(pageNo + "p. "):("")}}{{examNo}}.</button>
			<div v-if="mode == 'SCORE'" class="score-image" :style="'background-image:url('+scoreImage()+');'"></div>
		</div>
		<div class="item-inner item-cell">
			<div v-if="mode == 'ANSWER'" style="margin-bottom:4px;">
				<template v-for="(lecture, i) in lectures">
					<a class="text-color-primary margin-right" :key="'i' + i" v-if="lecture.blockOrder <= 10" style="white-space: nowrap;" v-on:click="onShowLectureClick($event, i)">
						<i class="f7-icons text-color-purple" style="vertical-align: text-bottom;">{{getIconName(lecture.lectureType)}}</i>
						<span>{{getLevelName(lecture.lectureLevel)}}</span>
					</a>
				</template>
			</div>
			<div v-else style="margin-bottom:4px;">
				<template v-for="(lecture, i) in lectures">
					<a v-bind:class="(correct != 'o') ? 'text-color-primary':'text-color-gray'" class="margin-right" :key="'i' + i" v-if="lecture.blockOrder > 10" style="white-space: nowrap;" v-on:click="onShowLectureClick($event, i)">
						<i class="f7-icons" v-bind:class="(correct != 'o') ? 'text-color-purple':'text-color-gray'" style="vertical-align: text-bottom;">{{getIconName(lecture.lectureType)}}</i>
						<span>{{getLevelName(lecture.lectureLevel)}}</span>
					</a>
				</template>
			</div>
			<div class="item-row">
				<button class="item-cell button" v-on:click="onNumberClick" v-bind:class="[isSelected('0') ? 'button-fill':'button-outline']">
					<span class="badge color-black" v-if="isDisplayAnswer('0')">1</span> 
					<span v-else>1</span>
				</button>
				<button class="item-cell button" v-on:click="onNumberClick" v-bind:class="[isSelected('1') ? 'button-fill':'button-outline']">
					<span class="badge color-black" v-if="isDisplayAnswer('1')">2</span> 
					<span v-else>2</span>
				</button>
				<button class="item-cell button" v-on:click="onNumberClick" v-bind:class="[isSelected('2') ? 'button-fill':'button-outline']">
					<span class="badge color-black" v-if="isDisplayAnswer('2')">3</span> 
					<span v-else>3</span>
				</button>
				<button class="item-cell button" v-on:click="onNumberClick" v-bind:class="[isSelected('3') ? 'button-fill':'button-outline']">
					<span class="badge color-black" v-if="isDisplayAnswer('3')">4</span> 
					<span v-else>4</span>
				</button>
				<button class="item-cell button" v-on:click="onNumberClick" v-bind:class="[isSelected('4') ? 'button-fill':'button-outline']">
					<span class="badge color-black" v-if="isDisplayAnswer('4')">5</span> 
					<span v-else>5</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import MODULE from '../../js/common/module';
import store from '../../js/store';
import CONST from '../../js/common/constant';
import AUTH from '../../js/common/auth';

import videojs from 'video.js';

export default {
	components: {
		
	},
	props: {
		seqIndex: { default: 0 },
		pageNo: { default: 0 },
		examNo: { default: 0 },
	},
	data() {
		return {
			
		}
	},
	computed: {
		mode() {
			var mode = this.getCommonObj().mode;
			return mode;
		},
		answer() {
			return this.getExam().answer;
		},
		inputAnswer: {
			get() {
				return this.getExam().inputAnswer;
			},
			set(newValue) {
				var exam = this.getExam();
				exam.inputAnswer = newValue;
			}
		},
		correct() {
			var correct = this.getExam().correct;
			if (MODULE.Util.isEmpty(correct)) {
				correct = "null";
			}

			return correct;
		},
		lectures() {
			return this.getExam().lectures;
		}
	},
	methods: {
		getCommonObj() {
			return store.getters.commonObj;
		},
		getExam() {
			var answers = this.getCommonObj().answers;

			var exam = answers[this.seqIndex];
			return exam;
		},
		isSelected(exampleIndex) {
			var exampleNo = Number(exampleIndex) + 1;
			return this.inputAnswer.includes(exampleNo);
		},
		isDisplayAnswer(exampleIndex) {
			var exampleNo = Number(exampleIndex) + 1;
			return this.mode=="SCORE" && this.answer.includes(exampleNo);
		},
		onNumberClick(e) {
			if (this.mode != "ANSWER") {
				return;
			}

			const thisButton = $(e.currentTarget);
			const parent = thisButton.parent();
			const buttons = parent.children("button");

			if (thisButton.hasClass("button-fill")) {
				thisButton.removeClass("button-fill");
				thisButton.addClass("button-outline");
			} else {
				thisButton.removeClass("button-outline");
				thisButton.addClass("button-fill");
			}

			let value = "";
			for (var i=0; i<buttons.length; i++) {
				let button = $(buttons[i]);

				if (button.hasClass("button-fill")) {
					if (value != "") {
						value = value + ".";
					}

					value = value + (i + 1);
				}
			}

			this.inputAnswer = value;
		},
		getIconName(lectureType) {
			if (lectureType == "c-otl" || lectureType == "e-otl") {
				return "arrowtriangle_right_circle";
			} else if (lectureType == "c-mp4" || lectureType == "e-mp4") {
				return "videocam_circle"
			} else if (lectureType == "c-img" || lectureType == "e-img") {
				return "photo";
			} else {
				return "question";
			}
		},
		getLevelName(lectureLevel) {
			return CONST.lectureLevelMap[lectureLevel].name;
		},
		scoreImage() {
			var correct = this.getExam().correct;

			if (MODULE.Util.isEmpty(correct)) {
				correct = "null";
			}

			return "static/score/" + correct + ".png";
		},
		onShowLectureClick(e, index) {
			var lectures = this.lectures;
			var lecture = lectures[index];
			var lectureType = lecture.lectureType;
			var lectureCode = lecture.lectureCode;

			if (lectureType == "c-img" || lectureType == "e-img") {
				MODULE.UITool.openMP4Dialog(lectureCode);
			} else if (lectureType == "c-mp4" || lectureType == "e-mp4") {
				MODULE.UITool.openMP4Dialog(lectureCode);
			} else if (lectureType == "c-otl" || lectureType == "e-otl") {
				const accessToken = AUTH.getAccessToken();
				MODULE.Util.appCall(accessToken, "show.otl", "lcode", lectureCode);
			}
		},
	}
}
</script>